import PropTypes from 'prop-types'
import React from 'react'

import ProductTile from './ProductTile'

function Grid({ products = [] }) {
  return (
    <ul className="product-grid" data-testid="product-listing">
      {products.map(({ fields }, index) => (
        <ProductTile key={`${fields.sku}_${index}`} productData={fields} />
      ))}
    </ul>
  )
}

Grid.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        sku: PropTypes.string,
      }),
    })
  ),
}

export default Grid
